<template>
  <div class="layout business-layout">
    <!-- <AppHeader :business-nav="true"/> -->
    <router-view/>
  </div>
</template>

<script>
import AppHeader from '@/components/common/AppHeader';

export default {
  name: 'BusinessLayout',
  components: {
    AppHeader,
  },
  mounted() {
    // check if import is maybe still in progress and subscribe to pusher if it is
    const importId = localStorage.getItem(`importUUID.${this.$route.params.merchant_id}`);
    if (importId) {
      // this.$store.dispatch('pusher/subscribeToImportStats', {
      //   importUUID: importId,
      //   merchantId: this.$route.params.merchant_id,
      // });
    }

    // add check for bulk
    const bulkSendUUID = localStorage.getItem(`_c_gm_pf_ns.${this.$route.params.merchant_id}`);
    if (bulkSendUUID) {
      // this.$store.dispatch('pusher/subscribeToBulkSendStats', {
      //   bulkSendUUID,
      //   merchantId: this.$route.params.merchant_id,
      // });
    }
  },
};
</script>
